export function reduce(it, f, start) {
    // https://surma.github.io/underdash/
    for (const v of it)
        start = f(start, v);
    return start;
}
